/* eslint-disable */

import { create } from "zustand";
import userAvatar from "../assets/images/man-avatar-profile-picture-vector-illustration_268834-538.avif";

export const useUserAuthToken = create((set) => ({
  userAuthToken: "",
  setUserAuthToken: (data) => set({ userAuthToken: data }),
}));

export const useUserData = create((set) => ({
  userData: null,
    setUserData: (data) => set({ userData: data }),
  }));

export const useAllUserDeets = create((set) => ({
  allUserDeets: {},
  setAllUserDeets: (data) => set({ allUserDeets: data }),
}));


export const useUserLoggedin = create((set) => ({
  userLoggedIn: localStorage.getItem("userLoggedin") || null,
  setUserLoggedIn: (data) => set({ userLoggedIn: data }),
}));

export const useUserAccessLevel = create((set) => ({
  accessLevel: localStorage.getItem("accessLevel") || "",
  setAccessLevel: (data) => set({ accessLevel: data }),
}));

export const useUserProfilePic = create((set) => ({
  userProfilePic: userAvatar,
  setUserProfilePic: (data) => set({ userProfilePic: data }),
}));

export const useUserPackage = create((set) => ({
  userPackage: localStorage.getItem("userPackage"),
  setUserPackage: (data) => set({ userPackage: data }),
}));